/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Center } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import empty from '../../../../../../../assets/vikingbet/images/backgrounds/empty.svg';
import { BetSlipEmptyImage } from '../../styles/Empty.styles';

export const template: TTemplate = {
  wrapper: <Center />,
  empty: <BetSlipEmptyImage src={empty} />,
};

export default template;
